import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalCardio = () => {

return(
<div>
    
<Typography variant="h6" >
GATA4 Transcription factor GATA-4 is a protein that in humans is encoded by the GATA4 gene. GATA4 is a critical transcription factor for proper mammalian cardiac development and essential for survival of the embryo. 
Mutations in this gene have been associated with cardiac septal defects as well as reproductive defects  (Wikipedia)
<br /><br /> 
GATA 4 -- role of GATA4 polymorphism in cardiovascular metabolic disorders    <br /> 
# Study implicates GATA4 in CAD (coronary artery disease) and its metabolic risk traits. <br /> 
# The finding also points to the possible involvement of yet undefined entities related to GATA4 transcription activity or gene regulatory pathways in events leading to these cardiovascular disorders.<br /> 
# rs804280 was associated with CAD, hypercholesterolaemia and elevated low-density lipoprotein-cholesterol (hLDLC) 
<br /><br /> 
HRAS rs12628 - HRAS belongs to the RAS genes superfamily. <br /> 
# RAS genes are important players in several human tumors and the single-nucleotide polymorphism rs12628 has been shown to contribute to the risk of bladder, colon, gastrointestinal, oral, and thyroid carcinoma.
<br /><br /> 
CPT2 rs1799821 -- Carnitine palmitoyltransferase II (CPT II) deficiency is one of the most common causes of fatty acid oxidation metabolism disorders.   
# CPT II deficiency induces an energy crisis of the fatty acid metabolic pathway
<br /><br />
SCN5A rs1805124 - SNP in the cardiac sodium channel SCN5A gene. quite common, seems to be considered to be a benign change  <br />
# Cardiac sodium channel (SCN5A) variants associated with atrial fibrillation = common arrhythmia<br />
# Atrial fibrillation happens when abnormal electrical impulses suddenly start firing in the atria. <br />
# These impulses override the heart's natural pacemaker, which can no longer control the rhythm of the heart. This causes you to have a highly irregular pulse rate.
<br /><br />
# EFEMP2 rs188624478 - benign
<br /><br />
# SLC12A3 Electroneutral sodium and chloride ion cotransporter, which acts as a key mediator of sodium and chloride reabsorption in kidney distal convoluted tubules.

<br /><br /> 

Sources: <br /><br />
https://humgenomics.biomedcentral.com/articles/10.1186/1479-7364-7-25   <br />
https://pubmed.ncbi.nlm.nih.gov/25781464/ <br />

https://pubmed.ncbi.nlm.nih.gov/25781464/   <br />
https://pubmed.ncbi.nlm.nih.gov/18378609/   <br />
httPubMed:21613606, PubMed:18270262, PubMed:22009145, PubMed:36351028, PubMed:36792826<br />


</Typography>

</div>
)
}